import React from 'react';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RoleRoute from './components/RoleRoute';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import HomePage from './pages/HomePage';
import UpgradePage from './pages/UpgradePage';
import Navbar from './components/Navbar';
import ProfilePage from './pages/ProfilePage';
import TotpPage from './pages/TotpPage';
import SyncPage from './pages/SyncPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Rutas protegidas que requieren autenticación */}
          <Route path="/profile" element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          } />
          
          <Route path="/totp" element={
            <PrivateRoute>
              <TotpPage />
            </PrivateRoute>
          } />
          
          {/* Rutas que requieren rol premium */}
          <Route path="/sync" element={
            <RoleRoute roles={['premium', 'admin']}>
              <SyncPage />
            </RoleRoute>
          } />
          
          {/* Rutas que requieren rol admin */}
          <Route path="/admin" element={
            <RoleRoute roles={['admin']}>
              <div style={{ padding: 32 }}>
                <h1>Panel de Administración</h1>
                <p>Gestión de usuarios, dispositivos, planes y métricas</p>
                {/* Aquí iría el componente AdminPanel */}
              </div>
            </RoleRoute>
          } />
          
          {/* Página de upgrade para usuarios free */}
          <Route path="/upgrade" element={<UpgradePage />} />
          
          {/* Ruta de fallback */}
          <Route path="*" element={
            <div style={{ padding: 32, textAlign: 'center' }}>
              <h1>404 - Página no encontrada</h1>
              <p>La página que buscas no existe.</p>
            </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
